import { Trans } from 'react-i18next'
import { t } from 'i18next'

import CheckInTab from './modal-check-in-tabs/check-in-tab/check-in-tab.component'
import ManageEquipmentsTab from './modal-check-in-tabs/manage-equipments-tab/manage-equipments-tab.component'
import WaitlineTab from './modal-check-in-tabs/waitline-tab/waitline-tab.component'

export const TABS = [
  {
    value: '1',
    label: <Trans i18nKey="checkIn:tabs.checkIn" />,
    content: <CheckInTab />,
  },
  {
    value: '2',
    label: <Trans i18nKey="checkIn:tabs.waitline" />,
    content: WaitlineTab,
  },
  {
    value: '3',
    label: <Trans i18nKey="checkIn:tabs.manageEquipment" />,
    content: <ManageEquipmentsTab />,
  },
]

export const TITLE = t('checkIn:checkIn')

export const PLACEHOLDER = t('checkIn:searchPlaceholder')

export const LABEL = t('common:search')

export const FORM_NAME = 'search'

export const PAGE_SIZE = 5
